import JsBarcode from 'jsbarcode';

export const generateEAN13 = (): string => {
  // Generate 12 random digits
  let code = '';
  for (let i = 0; i < 12; i++) {
    code += Math.floor(Math.random() * 10).toString();
  }
  
  // Calculate check digit
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const digit = parseInt(code[i]);
    sum += i % 2 === 0 ? digit : digit * 3;
  }
  
  const checkDigit = (10 - (sum % 10)) % 10;
  return code + checkDigit;
};

export const generateBarcodeImage = (code: string): string => {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, code, {
    format: 'EAN13',
    width: 2,
    height: 100,
    displayValue: true
  });
  return canvas.toDataURL();
};

export const isValidEAN13 = (code: string): boolean => {
  if (code.length !== 13) return false;
  
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const digit = parseInt(code[i]);
    if (isNaN(digit)) return false;
    sum += i % 2 === 0 ? digit : digit * 3;
  }
  
  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === parseInt(code[12]);
}; 